// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PlanLineReevaluationRunItem.yaml
// Generated: 2026-09-03T09:42:31.847Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { PlanLineReevaluationRunItem } from '@/types/finance/PlanLineReevaluationRunItem';

/**
 * PlanLineReevaluationRunItem Service (Read-Only)
 * Query operations for PlanLineReevaluationRunItem via the ABP API.
 */
export const planLineReevaluationRunItemService = new ReadOnlyEntityService<PlanLineReevaluationRunItem>(
  '/api/finance/planlinereevaluationrunitem',
  'PlanLineReevaluationRunItem',
);
